import UpdateProductPhoto from "./UpdateProductPhoto";

export default UpdateProductPhoto;
